import { render, staticRenderFns } from "./ZDialog.vue?vue&type=template&id=1c552e1c&"
import script from "./ZDialog.vue?vue&type=script&lang=js&"
export * from "./ZDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports